// Fit é aderência ao objeto. Preparação documental pertence ao checklist.
import { nivelFitUI } from './analise';

export interface FitTecnico {
  fit_score?: number | null;
  fit_tecnico_nivel?: string | null;
  fit_tecnico_justificativa?: string | null;
}

export function fitTecnicoUI(licitacao?: FitTecnico | null) {
  const score = licitacao?.fit_score;
  if (typeof score === 'number' && Number.isInteger(score) && score >= 0 && score <= 100) {
    return {
      label: String(score), completo: `${score}/100`,
      color: score >= 80 ? '#0a7f4a' : score >= 40 ? '#B07500' : '#B91626',
      tagColor: score >= 80 ? 'green' : score >= 40 ? 'orange' : 'red',
      dica: licitacao?.fit_tecnico_justificativa || 'Aderência técnica do objeto à Hydrodata.',
    };
  }
  const nivel = nivelFitUI(licitacao?.fit_tecnico_nivel);
  return {
    label: nivel.label, completo: nivel.label, color: nivel.color, tagColor: nivel.tagColor,
    dica: licitacao?.fit_tecnico_justificativa || 'Fit técnico ainda não avaliado.',
  };
}

export function textoPreparacaoDocumental(conteudo: string): string {
  try {
    const c = JSON.parse(conteudo);
    if (c && typeof c === 'object' && 'score' in c) {
      return `Preparação documental ${c.score != null ? `${c.score}/100` : 'sem itens aplicáveis'}: `
        + `${c.atende || 0} atende · ${c.atencao || 0} atenção · ${c.falta || 0} falta · ${c.pendente || 0} pendente`;
    }
  } catch { /* Registro antigo guardado como texto. */ }
  return String(conteudo || '').replace(/\bfit\s+(\d+\/100)/gi, 'preparação documental $1');
}
